import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import { accountType } from "custom-prop-types";
import { renderFormElement, FormButton } from "components/common/form-elements";

export const FavouriteAccount = (props) => {
  const selectedAccount = props.accounts.find((account) => account.id === props.favouriteAccountId);
  const mappedAccounts = props.accounts.map((account) => ({ key: account.id, name: account.label }));
  let initialValues;
  if (selectedAccount) {
    initialValues = { favouriteAccount: { key: selectedAccount.id, name: selectedAccount.label } };
  }
  mappedAccounts.unshift({ key: null, name: "No account" });
  return (
    <FavouriteAccountForm
      { ...props }
      accounts={ mappedAccounts }
      initialValues={ selectedAccount ? initialValues : null }
    />
  );
};

FavouriteAccount.propTypes = {
  accounts: PropTypes.arrayOf(accountType).isRequired
};

const StatelessFavouriteAccountForm = ({ accounts, onUpdateFavouriteAccount }) => (
  <form onSubmit={ (e) => { e.preventDefault(); onUpdateFavouriteAccount(); } }>
    <h1>Favourite Account</h1>
    <p>Set your favourite account!</p>
    <p>This account will be the account that opens by default whenever you enter Squirrel Street.</p>
    <p>If left unset, Squirrel Street will open the account that you used last.</p>
    { renderFormElement("Account List", "favouriteAccount", "select", accounts) }
    <FormButton text={ "Save Favourite Account" } />
  </form>
);

StatelessFavouriteAccountForm.propTypes = {
  accounts: PropTypes.arrayOf(accountType).isRequired,
  onUpdateFavouriteAccount: PropTypes.func.isRequired
};

const FavouriteAccountForm = reduxForm({ form: "favouriteAccountForm" })(StatelessFavouriteAccountForm);



// WEBPACK FOOTER //
// ./src/js/components/settings/favourite-account.jsx